import { useRef } from 'react';
import type { HighwayMaintenanceFeeTicketSummary } from '#/components/ui/tickets/highway-maintenance-fee/model';

export type ConfirmPaymentOnBehalfDialogRef = {
  confirm: (ticket: HighwayMaintenanceFeeTicketSummary) => Promise<boolean>;
};

export const useConfirmPaymentOnBehalfDialog = () => {
  const modalRef = useRef<ConfirmPaymentOnBehalfDialogRef>(null);
  const confirm = (ticket: HighwayMaintenanceFeeTicketSummary) =>
    modalRef.current?.confirm(ticket);
  return { props: { modalRef }, confirm };
};
